// extracted by mini-css-extract-plugin
export var container = "_8v-0";
export var error = "_8v-9";
export var label = "_8v-5";
export var light = "_8v-6";
export var md = "_8v-3";
export var sm = "_8v-2";
export var thin = "_8v-8";
export var thinBold = "_8v-7";
export var vertical = "_8v-4";
export var xs = "_8v-1";